var map = {
	"./Excel.png": "e766",
	"./ISOOC.png": "d108",
	"./OBSstudio.png": "9e7c",
	"./PPT.png": "2308",
	"./Photoshop.png": "8e05",
	"./Premiere.png": "5936",
	"./Processon.png": "0198",
	"./WeTool.png": "ecfb",
	"./Word.png": "bf74",
	"./X-mind.png": "5caa",
	"./ae.png": "165e",
	"./alibb.png": "eaec",
	"./bilibili.png": "c0ee",
	"./canva.png": "ca40",
	"./dou.png": "47f4",
	"./doudian.png": "5e75",
	"./douyin.png": "dfd7",
	"./feigua.png": "78a5",
	"./fengniao.png": "8477",
	"./geshihua.png": "82064",
	"./gongzhonghao.png": "e2ae",
	"./gouwuche.png": "0acc",
	"./hongshu.png": "9088",
	"./jianying.png": "6680",
	"./juliang.png": "59d3",
	"./kuaishou.png": "48b9",
	"./lianmeng.png": "3610",
	"./mama.png": "77d9",
	"./qianchuan.png": "db6f",
	"./qiye.png": "63b0",
	"./qunhuoma.png": "18d9",
	"./shipinzhibo.png": "7fe4",
	"./suanshu.png": "a0fa",
	"./suixintui.png": "eabe",
	"./taobaolianmeng.png": "648c",
	"./toutiao.png": "2e5e4",
	"./weibo.png": "99d7",
	"./weixin.png": "421d",
	"./wenjuanxing.png": "d79e",
	"./xiaodaka.png": "5ad9",
	"./xiaohao.png": "6daf",
	"./xiaoliebiao.png": "681a",
	"./xinbang.png": "746a",
	"./xingtu.png": "9f5c",
	"./xiumi.png": "6955",
	"./yiwu.png": "e2cb",
	"./youji.png": "4aa2",
	"./youmeiyou.png": "a381",
	"./zhibo.png": "1b4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15a1";